import { get, isFinite } from 'lodash';
import { defaultBodyBorderWidth } from '../message-defaults';
export var getBodyBorderWidth = function (composerData) {
    var getBorderWidth = function (path) {
        return parseInt(get(composerData, path), 10);
    };
    var customBorderWidth = getBorderWidth('background.body.borderWidth');
    if (isFinite(customBorderWidth)) {
        return customBorderWidth;
    }
    var fallbackBorderWidth = getBorderWidth('styles.css.so-global-body.borderWidth');
    if (isFinite(fallbackBorderWidth)) {
        return fallbackBorderWidth;
    }
    return defaultBodyBorderWidth;
};
//# sourceMappingURL=get-body-border-width.js.map